import * as React from 'react';

type FormOptionsContextValue = { showWarningsInitially: boolean };

export const FormOptionsContext = React.createContext<FormOptionsContextValue>({
  showWarningsInitially: false,
});
